// Invisible reCAPTCHA v3 utility
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

let scriptLoaded = false;
let scriptLoading = false;

function loadScript() {
  if (scriptLoaded || scriptLoading || !SITE_KEY) return Promise.resolve();
  scriptLoading = true;

  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    script.async = true;
    script.onload = () => {
      scriptLoaded = true;
      scriptLoading = false;
      resolve();
    };
    script.onerror = () => {
      scriptLoading = false;
      reject(new Error("Failed to load reCAPTCHA"));
    };
    document.head.appendChild(script);
  });
}

/**
 * Execute invisible reCAPTCHA v3 and return a token.
 * Returns null if reCAPTCHA is not configured (no site key).
 */
export async function getRecaptchaToken(action = "login") {
  if (!SITE_KEY) return null;

  try {
    await loadScript();
    return await new Promise((resolve) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(SITE_KEY, { action })
          .then(resolve)
          .catch(() => resolve(null));
      });
    });
  } catch {
    return null;
  }
}
